import { ITokenData } from '../../rest/oauth/oauth.models';
import { getTokenName } from './get-token-name';

export const setTokenToStorage = (tokenData: ITokenData) => {
  const tokenName = getTokenName();
  localStorage.setItem(tokenName, JSON.stringify(tokenData));
};
